/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer, useParameter, yearToCropYearShort, useDictionaryItem } from "../../shared";
import { CalendarControl } from "./controls/CalendarControl";
import { CommoditiesControl } from "./controls/CommoditiesControl";
import { BusinessUnitControl } from "./controls/BusinessUnitControl";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { dictionaryService } from "../../dataFlow";

export default function (props: { exportMode?: boolean }) {
  const { exportMode } = props;
  const description = [
    "Showing historical development of population, consumption per capita for crop commodities in major AP Lead Countries",
    "Self sufficiency refers to the latest  available year and is calculated as the ratio between Production and Domestic Consumption",
    "Source: USDA PSD, FAO Population, FAOStat / Global Insight (Fruits & Vegetables)",
    "Marketing Year: The marketing year starts directly after the crop year. In this year the crop finds its way to the market. E.g. the marketing year 11-12 markets the crops grown in the crop year 10-11",
  ];

  const [commodities] = useParameter<number[]>("@commodities_display");
  const [commName, setCommName] = React.useState("");
  const [commodityItem, commodityName] = useDictionaryItem(dictionaryService, "slides-commodities-display", Number(last(commodities)), {
    business_unit: 1,
    slide: 25,
  });
  React.useEffect(() => {
    if (commodityName) {
      setCommName(commodityName[9]);
    }
  }, [commodityName]);

  const [parameterValues] = useParameter<number[]>("@calendar");
  const [, calendarName] = useDictionaryItem(dictionaryService, "slides-calendar", last(parameterValues));
  const year = calendarName ? Number(calendarName) : new Date().getFullYear() - 1;
  const usdaSubtitle = `USDA marketing year (eg. ${yearToCropYearShort(year)} = Crop Year ${yearToCropYearShort(year - 1)})`;
  const comment = commodityItem?.getValue<string | null>("comment");
  const subtitle = !comment && comment !== "" ? usdaSubtitle : comment;
  const title = `AP major crops by lead countries – ${commName} self sufficiency, consumption per capita`;

  useExportQuery(title, subtitle);
  useFavourite();
  useSubscription();

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup>
          {/* <BusinessUnitControl /> */}
          <CommoditiesControl />
          <CalendarControl />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={25} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart-area-production-yield" />
          <ReportRenderer componentId="chart-net-trade" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
